@if (target$ | async; as link) {
  <a
    [finLink]="link.url"
    [external]="link.external"
    class="btn relative no-underline inline-block"
    [class.black-friday]="isBlackFriday$ | async"
    [openInNewTab]="link.external"
  >
    <span class="bold-type">{{ teaserTitle$ | async }}</span>
    @if (link.external) {
      <span class="is-vishidden">({{ 'ariaLabels.newTab' | finLocalization }})</span>
    }
  </a>
}
